import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"

export interface BlendNormalsSockets extends MaterialNodeSockets {
    inputs: {
        color1: "color"
        color2: "color"
    }
    settings: {
        color1: "color"
        color2: "color"
    }
    outputs: {
        color: "color"
    }
}

export const blendNormalsDefinition = {
    exchangeFormat: {
        nodeName: null,
    },
    nodeClass: "BlendNormals",
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color1: optionalMaterialInput, color2: optionalMaterialInput}),
            settings: z.strictObject({
                color1: z.optional(color),
                color2: z.optional(color),
            }),
            ui: materialUiSchema,
        }),
    },
    ui: {
        label: "Blend Normals",
        color: "#4987af",
        items: [
            {name: "color", label: "Color", valueType: "color", output: true},
            {name: "color1", label: "Color 1", valueType: "color", input: true, setting: true, defaultValue: {r: 0.5, g: 0.5, b: 1.0}},
            {name: "color2", label: "Color 2", valueType: "color", input: true, setting: true, defaultValue: {r: 0.5, g: 0.5, b: 1.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
} satisfies MaterialNodeDefinition<BlendNormalsSockets>
